import React, { useContext, useEffect, useState } from "react";
import { classNames } from "primereact/utils";
import { useHistory } from "react-router-dom";
import { CSSTransition } from "react-transition-group";
import { RTLContext } from "./App";
import { CognitoUserPool, CognitoUser } from "amazon-cognito-identity-js";
import { poolData } from "./lib/constants";
import { removeDomainName } from "./utilities/utillFunction";
import { superAdmin, designerAdmin } from "./lib/constants";
import NotificationComponent from "./components/Notification/NotificationComponent";

const userPool = new CognitoUserPool(poolData);
const AppTopbar = (props) => {
    let nqpermissions = JSON.parse(localStorage.getItem("permissions"));
    let username = localStorage.getItem("username");
    const { serviceTypeName } = JSON.parse(localStorage.getItem("service"));
    const { openSidebar } = useContext(RTLContext);
    const history = useHistory();
    const [custLogo, setCustLogo] = useState("");
    const [logo2, setLogo2] = useState("");
    const image = localStorage.getItem("profileImg");
    let admin = 0;

    const isSuperAdmin = nqpermissions.includes(superAdmin);
    const isDesignerAdmin = nqpermissions.includes(designerAdmin);

    JSON.parse(localStorage.getItem("permissions")).map((item) => {
        if (item === "BuildOperateDataPipelineSetup.READ" || item === "BuildOperateDataPipelineSetup.WRITE") admin++;
    });
    useEffect(() => {
        let imgs = JSON.parse(localStorage.getItem("service")).customer.images;
        let logo = JSON.parse(localStorage.getItem("service")).customer.logo2;
        setLogo2(logo);
        if (imgs) setCustLogo(imgs[imgs.length - 1]);
        // if (nqpermissions && nqpermissions.length) {
        //     let userPersmissions = nqpermissions.find((p) => {
        //         return p === "UserManagement.WRITE";
        //     });
        //     if (userPersmissions) {
        //         setIsDesignerAdmin(true);
        //     }
        // }
    }, []);

    const goLogin = () => {
        history.push("/login");
    };

    const signout = async () => {
        cognitoSignout();
        localStorage.clear();
        localStorage.clear();
        goLogin();
    };

    const cognitoSignout = () => {
        let userData = {
            Username: localStorage.getItem("email"),
            Pool: userPool,
        };

        let cognitoUser = new CognitoUser(userData);
        cognitoUser.signOut();
    };

    const onManageUsers = () => {
        history.push("/manage-users");
    };

    const onAddThing = () => {
        history.push("/allThings");
    };

    const onLogoClick = () => {
        let menu = JSON.parse(localStorage.getItem("menu")) || [];
        if (menu.length > 0) {
            history.push(removeDomainName(menu[0].url));
        } else {
            history.push("/");
        }
    };
    const changePassword = () => {
        history.push("/change-user-password");
    };
    const userNameOnNavbaar = (name) => {
        let finalName = "";
        if (name) {
            if (name.length >= 18) finalName = name.slice(0, 16) + "...";
            else finalName = name;
        }
        return finalName;
    };

    return (
        <div className="layout-topbar shadow-4">
            <div className="layout-topbar-left lg:mr-4 mr-0">
                {/* <button type="button" style={{ cursor: "pointer" }} className="layout-topbar-logo p-link" onClick={() => onLogoClick()}>
                    <img id="app-logo" src={process.env.PUBLIC_URL + "/assets/layout/images/Charcoal.svg"} alt="ultima-layout" style={{ height: "2.85rem", marginLeft: "-6.4rem" }} />
                    {/* <span className="text-3xl ml-2 charcoal-color font-larken white-space-nowrap">Imagine Home</span> */}
                {/* </button> */}
                <button type="button" style={{ cursor: "pointer", width: "auto", padding: "4px 6px" }} className="layout-topbar-logo p-link" onClick={() => onLogoClick()}>
                    <img id="app-logo" src={process.env.PUBLIC_URL + "/assets/layout/images/Cedar2.svg"} alt="ultima-layout" style={{ maxWidth: "100%", height: "100%" }} />
                </button>
                {/* <button type="button" className="layout-menu-button p-link" style={{ background: "transparent" }} onClick={props.onMenuButtonClick}>
                    <i className="pi pi-bars" style={{ color: "#47422F", fontSize: 24 }}></i>
                </button> */}
                {/* <button type="button" className="layout-topbar-mobile-button p-link">
                    <i className="pi pi-ellipsis-v fs-large" onClick={props.onMobileTopbarButtonClick}></i>
                </button> */}
                <button type="button" className="layout-menu-button shadow-6 p-link" style={{ backgroundColor: "#47422F", color: "#fff" }} onClick={props.onMenuButtonClick}>
                    <i className="pi pi-chevron-right" style={{ color: "#fff"}}></i>
                </button>
                
            </div>

            {/* <div className={classNames("layout-topbar-right", { "layout-topbar-mobile-active": props.mobileTopbarActive })}> */}
            <div className={classNames("layout-topbar-right")}>
                {/* <div className="layout-topbar-actions-left"> */}
                {/* <MegaMenu model={model} className="layout-megamenu" /> */}
                {/* </div> */}
                <div className="layout-topbar-actions-left">
                    <h2 style={{ color: "#47422F", fontFamily: "Larken", fontSize: 28, margin: 0, fontWeight: "500" }}>Welcome Home, {username}</h2>
                </div>
                <div className="layout-topbar-actions-right m-0 p-0 pr-2">
                    <ul className="layout-topbar-items" style={{ display: "flex", alignItems: "center", gap: 4, padding: 6 }}>
                        {isSuperAdmin && (
                            <li className="layout-topbar-items">
                                <button className="layout-topbar-action flex flex-row justify-content-center align-items-center px-2 rounded-sm p-link" onClick={() => history.push("/help")}>
                                    <i className="pi pi-question-circle fs-large" style={{ color: "#47422F" }}></i>
                                </button>
                            </li>
                        )}
                        <li className="layout-topbar-items">
                            <button className="layout-topbar-action flex flex-row justify-content-center align-items-center px-2 rounded-sm p-link" onClick={() => openSidebar(<NotificationComponent />)}>
                                <i className="pi pi-bell fs-large" style={{ color: "#47422F" }}></i>
                            </button>
                        </li>
                        {/* <li className="layout-topbar-item">
                            <div className="profile-box m-0 lg:mr-2" onClick={(event) => props.onTopbarItemClick({ originalEvent: event, item: "profile" })} style={{ cursor: "pointer" }}>
                                <button className="p-0" style={{ backgroundColor: "transparent", border: "none", cursor: "pointer" }}>
                                    {image ? <img src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(image)} alt="avatar" style={{ width: "30px", height: "30px", borderRadius: "50%" }} /> : <i className="pi pi-user fs-large "></i>}
                                </button>
                                <div className="lg:col-9 flex flex-column m-0 p-0 profileDetails">
                                    <p className="m-0 p-0" style={{ fontSize: "0.85rem", fontWeight: "700", fontStyle: "Inter", color: "#0F172A" }}>
                                        {userNameOnNavbaar(localStorage.getItem("username"))}
                                    </p>
                                    <p className="m-0 p-0 " style={{ color: "#74788D", fontSize: "12px", fontWeight: "700" }}>
                                        {admin === 2 && "Admin"}
                                    </p>
                                </div>
                            </div>
                            <CSSTransition classNames="p-toggleable" timeout={{ enter: 1000, exit: 450 }} in={props.activeTopbarItem === "profile"} unmountOnExit>
                                <ul className="layout-topbar-action-panel shadow-6" style={{ borderTop: "1px solid #e4e4e4", padding: "0" }}>
                                    <li className="layout-topbar-action-item" style={{ borderBottom: "1px solid #e4e4e4" }}>
                                        <div className="flex flex-row p-link">
                                            <button className="  px-2 rounded-circle p-link" onClick={(event) => props.onTopbarItemClick({ originalEvent: event, item: "profile" })}>
                                                {image ? <img src={process.env.REACT_APP_IMAGE_STATIC_URL + "/" + encodeURIComponent(image)} alt="avatar" style={{ width: "40px", height: "40px" }} /> : null}
                                            </button>
                                            <div className={image ? "col-8" : "col-10"}>
                                                <div style={{ marginLeft: "1.6rem" }}>
                                                    <div className="font-bold text-center">{localStorage.getItem("username")}</div>
                                                    <div className="text-center">{localStorage.getItem("email")}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    {isSuperAdmin || isDesignerAdmin ? (
                                        <li className="layout-topbar-action-item" onClick={onManageUsers}>
                                            <button className="flex flex-row align-items-center p-link">
                                                <i className="fa-regular fa-user mr-2"></i>
                                                <span>Manage Users</span>
                                            </button>
                                        </li>
                                    ) : null}

                                    <li className="layout-topbar-action-item" onClick={changePassword}>
                                        <button className="flex flex-row align-items-center p-link">
                                            <img style={{ marginRight: "0.5rem" }} src={process.env.PUBLIC_URL + "/images/change-password-icon.svg"} />
                                            <span>Change Password</span>
                                        </button>
                                    </li>
                                    <li className="layout-topbar-action-item" onClick={signout}>
                                        <button className="flex flex-row align-items-center p-link">
                                            <i className={classNames("pi pi-power-off", { "mr-2": !isRTL, "ml-2": isRTL })}></i>
                                            <span>Logout</span>
                                        </button>
                                    </li>
                                </ul>
                            </CSSTransition>
                        </li> */}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AppTopbar;
